<template>
    <button
        type="button"
        @click="loadPreviousStep"
        class="border-b border-gray text-base font-freizeit text-black opacity-25"
    >
        {{ $t('GO_BACK') }}
    </button>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        methods: {
            loadPreviousStep() {
                this.appStore.loadPreviousStep();
            },
        },
    };
</script>
